export default __webpack_public_path__ + "static/media/twitter.58bf1288.svg";